/**
 * EditProfile root page for editing the profile page
 */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import EditProfileUI from './EditProfile.ui';
import { connect } from 'react-redux';
import {
    fetchEditableProfile,
    fetchCompanyAds,
    updateField,
    publishProfile,
    unpublishProfile,
    uploadLogo,
} from '../../actions/profileActions';
import analytics, * as trackingTypes from '../../actions/analyticsActions';
import { createUrl } from '../../utils/createUrl';
import EditImage from './EditImage';

class EditProfile extends React.Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        match: PropTypes.shape({
            params: PropTypes.shape({
                id: PropTypes.string.isRequired,
            }).isRequired,
        }).isRequired,
        profile: PropTypes.shape({
            companyActiveAds: PropTypes.object.isRequired,
            error: PropTypes.object,
            loading: PropTypes.bool,
            loadingProfileBackground: PropTypes.bool,
            loadingProfileLogo: PropTypes.bool,
            profile: PropTypes.object.isRequired,
        }).isRequired,
    };

    componentDidMount() {
        const { id } = this.props.match.params;
        this.props.dispatch(analytics(trackingTypes.VIEW_EDIT_PROFILE, { id }));
        this.props.dispatch(fetchCompanyAds(id));
        this.props.dispatch(fetchEditableProfile(id));
    }

    onUpdateField = (id, update) => {
        this.props.dispatch(
            analytics(trackingTypes.UPDATE_FIELD, { name: update.name })
        );
        return this.props.dispatch(updateField(id, update));
    };

    onPreviewClick = () => {
        this.props.dispatch(analytics(trackingTypes.PREVIEW_CLICK));
    };

    onRequestPublish = (event) => {
        event.preventDefault();
        this.props.dispatch(publishProfile(this.props.profile.profile));
    };

    onRequestUnpublish = () => {
        this.props.dispatch(unpublishProfile(this.props.profile.profile));
    };

    onUploadLogo = (id, data) => {
        this.props.dispatch(uploadLogo(id, data));
    };

    render() {
        return (
            <Fragment>
                <Route
                    component={EditImage}
                    path={createUrl(
                        '/(bedrift/)?company/:id/edit/image/:imageId'
                    )}
                />
                <EditProfileUI
                    ads={this.props.profile.companyActiveAds}
                    dispatch={this.props.dispatch}
                    loading={this.props.profile.loading}
                    loadingProfileBackground={
                        this.props.profile.loadingProfileBackground
                    }
                    loadingProfileLogo={this.props.profile.loadingProfileLogo}
                    onPreviewClick={this.onPreviewClick}
                    onRequestPublish={this.onRequestPublish}
                    onRequestUnpublish={this.onRequestUnpublish}
                    onUpdateField={this.onUpdateField}
                    onUploadLogo={this.onUploadLogo}
                    profile={this.props.profile}
                    profileError={this.props.profile.error}
                    runIntro
                />
            </Fragment>
        );
    }
}

export default connect((state) => ({
    profile: state.profile,
}))(EditProfile);
